/* Detail Theory - paging for the Judge.me Cards Carousel.
 *
 * WHY THIS EXISTS. The carousel is laid out as two rows of cards by
 * assets/dt-judgeme-carousel.css, so one column holds two cards. The app's own
 * pager advances an index by one CARD and translates the container, which
 * assumes a single row: alternate clicks moved nothing and the previous arrow
 * did nothing at all. Its transform is overridden in CSS and the wrapper
 * scrolls natively instead, so the arrows need to drive that scroll.
 *
 * HOW. One delegated listener on the document in the CAPTURE phase. Capture
 * runs before the event reaches the button, so stopping propagation there means
 * the app's inline `onclick="window.jdgmPreviousCard(...)"` never fires. The
 * app's own functions are left untouched, because they are shared with every
 * other Judge.me widget in the store.
 *
 * The step is measured from a rendered card rather than assumed, because the
 * card width comes from a container query and is 620px on desktop and about
 * 308px on a phone.
 */
(function () {
  var GAP = 20;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var arrow = target.closest('.jdgm-cards-carousel .jdgm-arrow');
      if (!arrow) return;

      var carousel = arrow.closest('.jdgm-cards-carousel');
      var wrapper = carousel && carousel.querySelector('.jdgm-cards-wrapper');
      if (!wrapper) return;

      event.preventDefault();
      event.stopPropagation();

      var card = wrapper.querySelector('.jdgm-media-card');
      var step = card
        ? Math.round(card.getBoundingClientRect().width) + GAP
        : Math.round(wrapper.clientWidth / 2);

      var label = arrow.getAttribute('aria-label') || '';
      var back = /prev/i.test(label);

      wrapper.scrollBy({ left: back ? -step : step, behavior: 'smooth' });
    },
    true
  );
})();

/* The subheading under the carousel heading.
 *
 * sections/apps.liquid renders it from a section setting, outside the app block,
 * because the app exposes a header but no subheading and its heading is built
 * client side inside markup Liquid cannot reach. This moves it into
 * .jdgm-header once the widget exists, so it is real, selectable, accessible
 * text rather than CSS generated content.
 *
 * The cards render asynchronously, so this observes the document until the
 * header appears and then stops.
 */
(function () {
  function place() {
    var source = document.querySelector('[data-dt-reviews-subheading]');
    if (!source) return true;

    var header = document.querySelector('.jdgm-cards-carousel .jdgm-header');
    if (!header) return false;

    source.removeAttribute('hidden');
    header.appendChild(source);
    return true;
  }

  if (place()) return;

  var observer = new MutationObserver(function () {
    if (place()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Never observe forever. */
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
